import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=64a293b5&scoped=true&"
import script from "./reset.vue?vue&type=script&lang=js&"
export * from "./reset.vue?vue&type=script&lang=js&"
import style0 from "./reset.vue?vue&type=style&index=0&id=64a293b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a293b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/toshiya.murasaki/Docker/Laravel/TRIPLE-CROWN/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a293b5')) {
      api.createRecord('64a293b5', component.options)
    } else {
      api.reload('64a293b5', component.options)
    }
    module.hot.accept("./reset.vue?vue&type=template&id=64a293b5&scoped=true&", function () {
      api.rerender('64a293b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/member/password/reset.vue"
export default component.exports